import { createCommand } from 'lexical'


export const OPEN_SNIPPETS_COMMAND = createCommand(
  'OPEN_SNIPPETS_COMMAND'
)
